import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component3images from '../components/component3images'
import Componentparameters from '../components/componentparameters'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './arctic-white.css'

const ArcticWhite = (props) => {
  return (
    <div className="arctic-white-container">
      <Helmet>
        <title>
          Arcobo ArcticWhite | WAAM-принтер без лимитов по размерам деталей
        </title>
        <meta
          name="description"
          content="Открытая WAAM-платформа с конфигурацией под ваши детали. Проектирование системы без ограничений по размерам изделий, поставка в Казахстане и Узбекистане."
        />
        <meta
          property="og:title"
          content="Arcobo ArcticWhite | WAAM-принтер без лимитов по размерам деталей"
        />
        <meta
          property="og:description"
          content="Открытая WAAM-платформа с конфигурацией под ваши детали. Проектирование системы без ограничений по размерам изделий, поставка в Казахстане и Узбекистане."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Arcobo ArcticWhite | WAAM-принтер без лимитов по размерам деталей"
        />
        <meta
          name="twitter:description"
          content="Открытая WAAM-платформа с конфигурацией под ваши детали. Проектирование системы без ограничений по размерам изделий, поставка в Казахстане и Узбекистане."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/arctic-white"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/arctic-white"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"ArcticWhite","item":"https://arcobo.tech/arctic-white"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name7"></HeaderMain>
      <hr className="arctic-white-separator1"></hr>
      <Componenttextimage
        image1Src="/2_3D Printing/2_3_3D Printers/arcticwhite-1500w.webp"
        image1Alt="3D-принтер Arcobo ArcticWhite"
        mainHeading="Характеристики Arcobo ArcticWhite"
        rootClassName="componenttextimageroot-class-name11"
        textComponent={
          <Fragment>
            <span className="arctic-white-text100">
              <span className="H1_extrasmall">
                Кастомизированная WAAM-система для изготовления и восстановления
                металлических деталей без ограничений в размерах
              </span>
              <br></br>
              <span className="text_large">
                ArcticWhite сочетает узел печати и модульную архитектуру
                периферийного оборудования, позволяя печатать детали практически
                без ограничений по длине и выполнять восстановление
                крупногабаритных изделий непосредственно на предприятии.
              </span>
              <br></br>
              <br></br>
              <span className="H1_small">Преимущества и выгоды:</span>
              <br className="H1_small"></br>
              <span className="arctic-white-text108">✔</span>
              <span className="arctic-white-text109 H1_small"> </span>
              <span className="arctic-white-text110 H1_extrasmall">
                Неограниченные размеры деталей
              </span>
              <br></br>
              <span>
                Одна система подходит как для изготовления новых деталей, так и
                для восстановления дорогостоящих узлов методом роботизированной
                наплавки
              </span>
              <br></br>
              <span className="arctic-white-text114">✔ </span>
              <span className="arctic-white-text115 H1_extrasmall">
                Производство и ремонт
              </span>
              <br className="H1_extrasmall"></br>
              <span>
                Одна система подходит как для изготовления новых деталей, так и
                для восстановления дорогостоящих узлов методом роботизированной
                наплавки
              </span>
              <br></br>
              <span className="arctic-white-text119">✔ </span>
              <span className="arctic-white-text120 H1_extrasmall">
                Масштабируемая архитектура
              </span>
              <br></br>
              <span>
                Конфигурация комплекса адаптируется под размеры изделий,
                производительность и задачи конкретного предприятия
              </span>
              <br></br>
              <span className="arctic-white-text124">✔ </span>
              <span className="arctic-white-text125 H1_extrasmall">
                Полностью локальная интеграция
              </span>
              <br></br>
              <span>
                Проектирование, изготовление, программирование и сервис
                выполняются инженерами Arcobo в Казахстане
              </span>
            </span>
          </Fragment>
        }
        componentTitle="Arcobo ArcticWhite"
      ></Componenttextimage>
      <Component3images
        image1Src="/2_3D Printing/3d_01-200h.webp"
        image1Alt="WAAM 3D-печать металлом"
        image2Src="/2_3D Printing/3d_02-200h.webp"
        image2Alt="WAAM 3D-печать металлом"
        image3Src="/2_3D Printing/3d_03-200h.webp"
        image3Alt="WAAM 3D-печать металлом"
        rootClassName="component3imagesroot-class-name19"
      ></Component3images>
      <Componentparameters
        text1={
          <Fragment>
            <span className="arctic-white-text128">
              <span className="arctic-white-text129">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Промышленный робот-манипулятор</span>
              <br></br>
              <span className="arctic-white-text132">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Цифровой сварочный источник</span>
              <br></br>
              <span className="arctic-white-text135">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система подачи сварочной проволоки</span>
              <br></br>
              <span className="arctic-white-text138">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система 3D-сканирования</span>
              <br></br>
              <span className="arctic-white-text141">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система контроля температуры детали</span>
              <br></br>
              <span className="arctic-white-text144">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система снижения расходы защитного газа</span>
              <br></br>
              <span className="arctic-white-text147">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Контроллер управления роботизированным комплексом</span>
              <br></br>
              <span className="arctic-white-text150">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Программное обеспечение Arcobo WAAM</span>
              <br></br>
              <span className="arctic-white-text153">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Защитные ограждения с датчиками безпасности</span>
              <br></br>
            </span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="arctic-white-text156">
              <span>
                Тип процесса:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="arctic-white-text158">MIG/MAG/TIG/PAW/LW</span>
              <br></br>
              <span>
                Онлайн-мониторинг печати:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="arctic-white-text161">Да</span>
              <br></br>
              <span>
                Производительность печати:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="arctic-white-text164">до 5 кг/час (сталь</span>
              <span>)</span>
              <br></br>
              <span>
                Максимальная масса детали:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="arctic-white-text168">10 тонн</span>
              <br></br>
              <span>
                Максимальные габариты детали:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="arctic-white-text171">5 м</span>
              <br></br>
              <span>
                Точность позиционирования:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="arctic-white-text174">±0,06 мм</span>
              <br></br>
              <span>Диаметры проволоки:</span>
              <span className="arctic-white-text177"> 1,0-2,4 мм</span>
              <br></br>
              <span>
                Напряжение питания:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="arctic-white-text180">380 В, 50 Гц</span>
              <br></br>
              <span>
                Потребляемая мощность:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="arctic-white-text183">20–25 кВт</span>
            </span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="arctic-white-text184">
              <span className="arctic-white-text185">•</span>
              <span className="arctic-white-text186">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Технология печати целевых деталей</span>
              <br></br>
              <span className="arctic-white-text189">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Пусконаладочные работы</span>
              <br></br>
              <span className="arctic-white-text192">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Обучение персонала. Базовый курс 4 дня</span>
            </span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="arctic-white-text194">
              <span className="arctic-white-text195">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Линейная ось (до 18 м)</span>
              <br></br>
              <span className="arctic-white-text198">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Вращатели и позиционеры (до 5 осей в однм устройстве)</span>
              <br></br>
              <span className="arctic-white-text201">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Дополнительные внешние оси</span>
              <br></br>
              <span className="arctic-white-text204">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Стол, адаптированный под целевые деталивнешние оси</span>
              <br></br>
              <span className="arctic-white-text207">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Оснастка под целевые детали</span>
            </span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="arctic-white-text209">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur
            </span>
          </Fragment>
        }
        heading1="A. Базовая комплектация"
        heading2="B. Базовые характеристики"
        heading3="C. В состав поставки включены:"
        heading4="D. Дополнительные опции"
        showDiv1
        showDiv5={false}
        mainHeading="Характеристики Arcobo ArcticWhite"
        rootClassName="componentparametersroot-class-name4"
      ></Componentparameters>
      <Component3images
        image1Src="/2_3D Printing/3d_11-200h.webp"
        image1Alt="Изделие WAAM 3D-печати"
        image2Src="/2_3D Printing/3d_12-200h.webp"
        image2Alt="Изделие WAAM 3D-печати"
        image3Src="/2_3D Printing/3d_13-200h.webp"
        image3Alt="Изделие WAAM 3D-печати"
        rootClassName="component3imagesroot-class-name20"
      ></Component3images>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="arctic-white-text210">
              <span>
                Изготавливаются функциональные металлические детали массой от
                нескольких килограммов до нескольких тонн: корпуса, крыльчатки,
                сопла, оснастка, пресс-формы, заготовки и детали сложной
                геометрии. ArcticWhite особенно эффективен для единичного и
                мелкосерийного производства крупногабаритных изделий.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="arctic-white-text213">
              <span>
                Технология наиболее эффективна при изготовлении единичных и
                мелкосерийных деталей, крупных изделий, дорогостоящих сплавов и
                деталей с длительными сроками поставки. WAAM позволяет
                отказаться от дорогостоящей литейной оснастки и значительно
                сократить сроки производства.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="arctic-white-text216">
              <span>
                Поддерживается печать более чем из 100 металлических сплавов,
                включая конструкционные и нержавеющие стали, инструментальные
                стали, алюминиевые, бронзовые, никелевые и титановые сплавы.
                Конкретный перечень материалов определяется конфигурацией
                комплекса.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="arctic-white-text219">
              <span>
                Стоимость зависит от материала, массы детали, сложности
                геометрии, объема последующей мехобработки и размера партии. Для
                большинства единичных изделий расчет выполняется индивидуально
                на основе CAD-модели.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="arctic-white-text222">
              <span>
                Для предприятий с регулярной потребностью в изготовлении или
                восстановлении металлических деталей инвестиции в WAAM обычно
                окупаются за счет сокращения сроков производства, снижения
                закупочных затрат и отказа от дорогостоящей оснастки. Конкретный
                срок окупаемости определяется производственной программой
                предприятия.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="arctic-white-text225">answer</span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="arctic-white-text226">answer</span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="arctic-white-text227">answer</span>
          </Fragment>
        }
        showDiv5
        showDiv6
        showDiv7
        question1="Какие детали можно изготавливать?"
        question2="Когда WAAM выгоднее традиционного производства?"
        question3="Из каких материалов можно печатать?"
        question4="Сколько стоит изготовление детали методом WAAM?"
        question5="Какой срок окупаемости WAAM?"
        mainHeading="Характеристики Arcobo ArcticWhite"
        rootClassName="componentfaqroot-class-name10"
      ></Componentfaq>
      <hr className="arctic-white-separator2"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name7"></FooterMain>
    </div>
  )
}

export default ArcticWhite
